import React from 'react';
import { WidgetComponent } from './casino_section_components';

export default (props) => (
  <WidgetComponent {...props} className="right-sidebar-components__widget" title />
);
